import { prop, sort, compose, toPairs, map, not, anyPass, isEmpty, isNil, defaultTo, head, last, curry, inc, length, dec, findIndex, propEq, pathOr } from 'ramda'

export const getLocalStorage = (key, defaultValue) => {
  return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : defaultValue
}

export const setLocalStorage = (key, value = '') => {
  return localStorage.setItem(key, JSON.stringify(value))
}

export const parseObjectToArray = compose(
  map(x => ({ to: head(x), ...last(x) })),
  toPairs
)

export const isExists = compose(
  not,
  anyPass([isEmpty, isNil])
)

export const isNotNil = compose(not, isNil)

export const isNotNilDataByKey = (data, key) => {
  return compose(
    not,
    isNil,
    prop(key),
    head,
    prop('data')
  )(data)
}

export const getResponseData = compose(
  defaultTo([]),
  head,
  prop('data')
)

export const getTranslation = curry((data, key) => {
  return compose(
    prop(key),
    head,
    prop('data')
  )(data)
})

export const getData = compose(
  defaultTo([]),
  prop('data'),
  head,
  prop('data')
)

export const getDataByKey = (data, key, defaultVal = '') => {
  return compose(
    defaultTo(defaultVal),
    prop(key),
    head,
    prop('data')
  )(data)
}

export const getTitleByKey = (data, key, defaultVal = '') => {
  return compose(
    defaultTo(defaultVal),
    prop('title'),
    prop(key),
    head,
    prop('data')
  )(data)
}

export const getOrderByKey = (data, key, defaultVal = '') => {
  return compose(
    defaultTo(defaultVal),
    prop('order'),
    prop(key),
    head,
    prop('data')
  )(data)
}

export const getOrder = compose(
  defaultTo([]),
  prop('order'),
  head,
  prop('data')
)

export const getFirstCowId = curry((sortList, data) => {
  return compose(
    pathOr(null, ['row_id']),
    head,
    sortList,
    pathOr([], ['cowslist', 'cows']),
    head,
    pathOr([], ['data'])
  )(data)
})

export const renderData = curry(({ fetching, error, data }, methods) => {
  if (fetching) {
    return methods.fetching(fetching)
  } else if (error) {
    return methods.error(error)
  } else {
    return methods.data(data)
  }
})

export const sortByInt = (order = {}) => sort((a, b) => {
  const { direct = 'asc', key = 'order' } = order
  const _a = parseInt(a[key], 10)
  const _b = parseInt(b[key], 10)

  if (_a === _b) return 0
  else if (isNaN(_a)) return 1
  else if (isNaN(_b)) return -1
  else if (direct === 'asc') return _a < _b ? -1 : 1
  else if (direct === 'desc') return _a < _b ? 1 : -1
})

export const sortByFloat = (key) => (order = {}) => sort((a, b) => {
  const { direct: orderDirect = 'asc', key: orderKey = 'order' } = order
  let _a = a[orderKey][key];
  let _b = b[orderKey][key];
  _a = _a && parseFloat(_a.replace(/:/g, ""));
  _b = _b && parseFloat(_b.replace(/:/g, ""));

  if (_a === _b) return 0
  else if (isNaN(_a)) return 1
  else if (isNaN(_b)) return -1
  else if (orderDirect === 'asc') return _a < _b ? -1 : 1
  else if (orderDirect === 'desc') return _a < _b ? 1 : -1
})

export const validateEmail = email => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)

export const findIndexByKey = (key, item, list) => {
  return findIndex(propEq(key, item), list)
}

export const findNextIndex = (currIndex, list) => {
  const nextIndex = inc(currIndex)
  return nextIndex >= length(list) ? 0 : nextIndex
}

export const findPrevIndex = (currIndex, list) => {
  const prevIndex = dec(currIndex)
  return prevIndex < 0 ? dec(length(list)) : prevIndex
}

export const parseMygrplist = compose(
  map(item => ({ value: item.grp_id === null ? '' : item.grp_id, label: item.grp_name })),
  defaultTo([]),
)